import { Controller } from "@hotwired/stimulus";

// Manages allergen checkbox grid with selected count display
export default class extends Controller {
  static targets = ["checkbox", "count", "label"];
  static values = { max: { type: Number, default: 14 } };

  connect() {
    this._updateCount();
    this._updateLabels();
  }

  toggle() {
    this._updateCount();
    this._updateLabels();
  }

  // Private

  _updateCount() {
    if (!this.hasCountTarget) return;

    const selected = this.checkboxTargets.filter((el) => el.checked);
    this.countTarget.textContent = `(${selected.length}/${this.maxValue})`;
  }

  _updateLabels() {
    this.labelTargets.forEach((label) => {
      const checkbox = label.querySelector("input[type='checkbox']");
      if (checkbox && checkbox.checked) {
        label.classList.add("border-primary", "bg-primary/10");
      } else {
        label.classList.remove("border-primary", "bg-primary/10");
      }
    });
  }
}
